import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SendFlowToDeviceModalComponent } from './send-flow-to-device-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatProgressSpinnerModule,
    ],
    declarations: [SendFlowToDeviceModalComponent],
    exports: [SendFlowToDeviceModalComponent],
})
export class SendFlowToDeviceModalModule {}
